import { IMerchandiseItem } from '@/common/interfaces/merchandise.interface';
import { IProduct } from '@/common/interfaces/products.interface';
import FetchHelper from '../helpers/OldFetchHelper';
import OldErrorHandlerHelper from '../helpers/OldErrorHandlerHelper';
import ZApiService from './ZApiService';
import ProductHelper from '@/helpers/ProductHelper';

export default class ProductService {
  private zApiService: ZApiService;
  partnerProductBusinessCardMatchCodes: string[] = [];
  partnerProductCarDecalMatchCodes: string[] = [];

  matchcodesInitialized = false;

  public constructor(zApiService: ZApiService) {
    this.zApiService = zApiService;
  }

  private async init(): Promise<void> {
    await this.fetchMerchandiseMatchcodes();
  }

  public async fetchMerchandiseMatchcodes(): Promise<void> {
    const fetchResult = await FetchHelper.get({ path: `/products/merchandise/matchcodes` });
    if(fetchResult.success) {
      this.partnerProductBusinessCardMatchCodes = fetchResult.data.businessCards;
      this.partnerProductCarDecalMatchCodes = fetchResult.data.carDecals;
      this.matchcodesInitialized = true;
    } else {
      OldErrorHandlerHelper.handleError(fetchResult, { logToConsole: true });
    }
  }

  public async isBusinessCard(productInfo: IProduct | IMerchandiseItem): Promise<boolean> {
    if(!productInfo) {
      return false;
    }
    if(!this.matchcodesInitialized) {
      // prevent race conditions
      await this.init();
    }
    return this.partnerProductBusinessCardMatchCodes.includes(productInfo.matchcode);
  }

  public async isCarDecal(productInfo: IProduct | IMerchandiseItem): Promise<boolean> {
    if(!productInfo) {
      return false;
    }
    if(!this.matchcodesInitialized) {
      // prevent race conditions
      await this.init();
    }
    return this.partnerProductCarDecalMatchCodes.includes(productInfo.matchcode);
  }

  public async getHomepageOfferProducts(): Promise<IProduct[]> {
    const allReducedProducts = await this.zApiService.getReducedProducts();
    return allReducedProducts
      .filter(product => !product.partnerApplicationProduct && product.purchasePossible)
      .map(product => ProductHelper.transformProductInfosToLocizeKeys(product))
      .sort((a, b) => (a.prices.customer.brutto > b.prices.customer.brutto ? -1 : 1));
  }

  public async getProductInfos(matchcode: string): Promise<IProduct> {
    const product = await this.zApiService.getProductInfos(matchcode);
    return ProductHelper.transformProductInfosToLocizeKeys(product);
  }
}
